import { render, staticRenderFns } from "./List.vue?vue&type=template&id=b5ae0ef6&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=b5ae0ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ae0ef6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ItemCard: require('/home/bitrix/frontend/components/gallery/ItemCard.vue').default})
